import EntityModel from '@/common/models/entity-model';

export class PricingBracketModel extends EntityModel {
    hydrate({
        price = null,
        maxQuantity = null,
    } = {}) {
        this.price = price;
        this.maxQuantity = maxQuantity;
    }

    getPayload() {
        return {
            price: this.price,
            maxQuantity: this.maxQuantity,
        };
    }
}

export default class PlanFormulaModel extends EntityModel {
    hydrate({
        formula = PlanFormulaModel.SimpleFormulas.flatRate,
        price = 0,
        maxQuantity = null,
        brackets = [],
    } = {}) {
        this.formula = formula;

        switch (this.formula) {
            case PlanFormulaModel.Formulas.fixedFee:
                this.price = price;
                break;
            case PlanFormulaModel.Formulas.flatRate:
                this.price = price;
                this.maxQuantity = maxQuantity;
                break;
            case PlanFormulaModel.Formulas.stairstep:
            case PlanFormulaModel.Formulas.tiered:
            case PlanFormulaModel.Formulas.volume:
                this.brackets = brackets.map(bracket => new PricingBracketModel(bracket));
                break;
            default:
                break;
        }
    }

    static SimpleFormulas = {
        fixedFee: 'fixed-fee',
        flatRate: 'flat-rate',
    };

    static BracketFormulas = {
        stairstep: 'stairstep',
        tiered: 'tiered',
        volume: 'volume',
    };

    static Formulas = {
        ...PlanFormulaModel.SimpleFormulas,
        ...PlanFormulaModel.BracketFormulas,
    };

    get isSimple() {
        return Object.values(PlanFormulaModel.SimpleFormulas).includes(this.formula);
    }

    get isBracket() {
        return Object.values(PlanFormulaModel.BracketFormulas).includes(this.formula);
    }

    getPayload() {
        const brackets = this.brackets
            ? this.brackets.map(bracket => bracket.getPayload())
            : this.brackets;

        return {
            formula: this.formula,
            price: this.price,
            maxQuantity: this.maxQuantity,
            brackets,
        };
    }
}
